<template>
    <div>

      <div v-for="(tileData, index) in tilesData">
          <template v-if="(($store.state.sklad.id_skladu != 12 && $store.state.sklad.id_skladu != 13) || (tileData['href'] == '/vydejky' || tileData['href'] == '/vydejky/nova-vydejka'))">
              <homepage-tile
                  :text="tileData['text']"
                  :icon="tileData['icon']"
                  :href="tileData['href']"
                  :index="index"
                  :counter="tileData['counter']"
                  :counterColor="tileData['counterColor']"
                  :dokoncenaAgenda="tileData['dokoncena_agenda']"
              />
          </template>
      </div>
    </div>
</template>

<script>
import HomepageTile from "@/components/homepage/HomepageTile";
import axiosApiPostV2 from "@/router/axiosApiMethod";

export default {
    name: "Homepage",
    components: {HomepageTile, axiosApiPostV2},
    data() {
        return {
            counterArray: {},
            tilesData: {},
            appLocation: window.appLocation
        }
    },
    created() {
        this.$root.$emit('showLoader', {show: true});
        this.getMenu();
    },
    methods: {
      async getMenu() {
        Helper.getMenu().then( result => {
          this.tilesData = result;
          this.$root.$emit('showLoader', {show: false});
        });
      }
    }
}
</script>

<style lang="scss" scoped>

</style>